import { createSlice } from '@reduxjs/toolkit';

export interface ChatState {
  conversations: {
    data?: [
      {
        id: string;
        channelType: 'whatsapp' | 'instagram' | 'webchat';
        channel?: { name: string };
        contact: { name: string; phoneNumber: string; avatar: string };
        updatedAt: '';
        lastMessage: {
          contentType: string;
          content: {
            rendered: {
              text: string;
            };
            text: string;
          };
          createdAt: string;
        };
      }
    ];
    current?: {
      id?: string;
      status?: 'resolved' | 'open' | 'assigned';
      isReplyGPT?: boolean;
      contact?: { name: string; phoneNumber: string; id: string };
      agent?: { id: string; user: { name: string; email: string } };
      resolvedAt?: string;
      assignAt?: string;
      channelId?: string;
      channelType?: 'whatsapp' | 'instagram' | 'webchat';
      note?: string;
      expireAt?: string;
    };
    statusFilter?: 'open' | 'assigned' | 'resolved' | 'all';
    channelsFilter?: string;
    waChannelsFilter?: string;
    waFilter?: 'all' | 'active' | 'expired';
    agentFilter?: string;
    search?: string;
    // BINUS POC filters
    isActiveFilter?: string; // '' | 'true' | 'false'
    academicCareerFilter?: string; // '' | 'S1' | 'S2' | 'S3'
    leadStatusFilter?: string; // '' | 'hot' | 'warm' | 'cold'
  };
  messages: { data?: [] };
  conversationId?: string;
}

const initialState: ChatState = {
  conversations: {
    statusFilter: 'all',
    channelsFilter: '',
    waChannelsFilter: '',
    current: { id: '', isReplyGPT: false },
    agentFilter: '',
    waFilter: 'all',
    isActiveFilter: '',
    academicCareerFilter: '',
    leadStatusFilter: '',
  },
  messages: { data: [] },
  conversationId: '',
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setConversationId: (state, action) => {
      state.conversationId = action.payload;
    },
    setConversation: (state, action) => {
      state.conversations.data = action.payload;
    },
    setCurrenConversation: (state, action) => {
      state.conversations.current = action.payload;
    },
    setMessage: (state, action) => {
      state.messages = action.payload;
    },
    setStatusFilter: (state, action) => {
      state.conversations.statusFilter = action.payload;
    },
    setChannelFilter: (state, action) => {
      state.conversations.channelsFilter = action.payload;
    },
    setSearchFilter: (state, action) => {
      state.conversations.search = action.payload;
    },
    setAgentFilter: (state, action) => {
      state.conversations.agentFilter = action.payload;
    },
    setWaFilter: (state, action) => {
      state.conversations.waFilter = action.payload;
    },
    setWaChannelFilter: (state, action) => {
      state.conversations.waChannelsFilter = action.payload;
    },
    // BINUS POC reducers
    setIsActiveFilter: (state, action) => {
      state.conversations.isActiveFilter = action.payload;
      // Reset dependent filters when switching type
      state.conversations.academicCareerFilter = '';
      state.conversations.leadStatusFilter = '';
    },
    setAcademicCareerFilter: (state, action) => {
      state.conversations.academicCareerFilter = action.payload;
    },
    setLeadStatusFilter: (state, action) => {
      state.conversations.leadStatusFilter = action.payload;
    },
    clearFilter: (state) => {
      state.conversations.search = '';
      state.conversations.channelsFilter = '';
      state.conversations.agentFilter = '';
      state.conversations.waFilter = 'all';
      state.conversations.waChannelsFilter = '';
      state.conversations.isActiveFilter = '';
      state.conversations.academicCareerFilter = '';
      state.conversations.leadStatusFilter = '';
    },
  },
});

export const {
  setConversation,
  setMessage,
  setCurrenConversation,
  setStatusFilter,
  setChannelFilter,
  setConversationId,
  setSearchFilter,
  setAgentFilter,
  setWaFilter,
  setWaChannelFilter,
  clearFilter,
  // BINUS POC
  setIsActiveFilter,
  setAcademicCareerFilter,
  setLeadStatusFilter,
} = chatSlice.actions;
export default chatSlice.reducer;
